// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import './scss/style.scss';
import store from './store'
import { theme } from './theme'
import { datetime } from './filters'
import PageContent from './components/UI/Layout/PageContent'
import Title from './components/UI/Layout/Title'
import { mixin } from './mixin';
import Vuelidate from 'vuelidate';
import VueCookies from 'vue-cookies';

import './register-sw';

Vue.use(Vuetify, { theme })
Vue.use(Vuelidate)
Vue.use(VueCookies)
VueCookies.config('180d')
// Vue.use(Vuetify)

// General Mixins
Vue.mixin(mixin)

window.moment = require('moment')
window.toastr = require('vuetify-toast')
window.$ = window.jQuery = require('jquery')

Vue.config.productionTip = false

// general components
Vue.component('app-page-content', PageContent);
Vue.component('app-title', Title);

// Filtros de vue
Vue.filter('datetime', datetime);

let EventBus = new Vue();
// Asignar bus de eventos globales
Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function () {
            return EventBus;
        }
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js